import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import StudentPortal from "@/pages/StudentPortal";
import CoursesPublic from "@/pages/CoursesPublic";
import PaymentReturn from "@/pages/PaymentReturn";
import SignerPortal from "@/pages/SignerPortal";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Employees from "@/pages/Employees";
import Portals from "@/pages/Portals";
import LegalRequirements from "@/pages/LegalRequirements";
import SafetyTalks from "@/pages/SafetyTalks";
import PPE from "@/pages/PPE";
import PpeCatalog from "@/pages/PpeCatalog";
import Incidents from "@/pages/Incidents";
import Waste from "@/pages/Waste";
import Documents from "@/pages/Documents";
import Medicine from "@/pages/Medicine";
import ISO14001 from "@/pages/ISO14001";
import Trainings from "@/pages/Trainings";
import Inspections from "@/pages/Inspections";
import EnvAspects from "@/pages/EnvAspects";
import EnvironmentPanel from "@/pages/EnvironmentPanel";
import Tutorial from "@/pages/Tutorial";
import Licenses from "@/pages/Licenses";
import Cipa from "@/pages/Cipa";
import ServiceOrders from "@/pages/ServiceOrders";
import UsersPage from "@/pages/Users";
import Settings from "@/pages/Settings";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children, adminOnly }) {
  const { user, isAdmin } = useAuth();
  if (user === undefined)
    return (
      <div className="flex h-screen items-center justify-center bg-[#F8FAFC]">
        <Loader2 className="h-8 w-8 animate-spin text-[#134074]" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/landing" element={<Navigate to="/login" replace />} />
      <Route path="/escola" element={<StudentPortal />} />
      <Route path="/cursos" element={<CoursesPublic />} />
      <Route path="/payment/success" element={<PaymentReturn />} />
      <Route path="/payment/cancel" element={<PaymentReturn cancel />} />
      <Route path="/assinaturas" element={<SignerPortal />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="dds" element={<SafetyTalks />} />
        <Route path="epis" element={<PPE />} />
        <Route path="epi-catalogo" element={<PpeCatalog />} />
        <Route path="ocorrencias" element={<Incidents />} />
        <Route path="treinamentos" element={<Trainings />} />
        <Route path="inspecoes" element={<Inspections />} />
        <Route path="cipa" element={<Cipa />} />
        <Route path="ordens-servico" element={<ServiceOrders />} />
        <Route path="residuos" element={<Waste />} />
        <Route path="iso14001" element={<ISO14001 />} />
        <Route path="aspectos" element={<EnvAspects />} />
        <Route path="painel-ambiental" element={<EnvironmentPanel />} />
        <Route path="licencas" element={<Licenses />} />
        <Route path="tutorial" element={<Tutorial />} />
        <Route path="medicina" element={<Medicine />} />
        <Route path="colaboradores" element={<Employees />} />
        <Route path="portais" element={<Portals />} />
        <Route path="requisitos-legais" element={<LegalRequirements />} />
        <Route path="documentos" element={<Documents />} />
        <Route path="usuarios" element={<ProtectedRoute adminOnly><UsersPage /></ProtectedRoute>} />
        <Route path="configuracoes" element={<ProtectedRoute adminOnly><Settings /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
